import { Injectable } from '@angular/core';
import { AnalyticsService } from '@cigna/shared/angular/analytics-data-access';

@Injectable({ providedIn: 'root' })
export class LoginDataAccessTrackHandlers {
  factorTypeMap = { sms: 'Phone', email: 'Email' };
  constructor(private _rootAnalytics: AnalyticsService) {}

  trackFactorVerificationEmail(isAfterRegistration: boolean) {
    this._rootAnalytics.trackEvent({
      channel: isAfterRegistration ? 'Registration' : 'Login',
      prop13: 'ac24156',
      prop67: 'action',
      eVar119: 'DOTD-335',
      linkName: 'MFA Email Setup Complete',
      eVar120: 'mfa-setup-completed-indicator',
    });
  }
  trackFactorVerificationPhone(isAfterRegistration: boolean) {
    this._rootAnalytics.trackEvent({
      channel: isAfterRegistration ? 'Registration' : 'Login',
      prop13: 'ac24157',
      prop67: 'action',
      eVar119: 'DOTD-336',
      linkName: 'MFA Phone Verification Success',
      eVar120: 'mfa-phone-verification-success',
    });
  }
  trackFactorVerificationSuccess() {
    this._rootAnalytics.trackEvent({
      channel: 'Login',
      prop13: 'ac24158',
      prop67: 'action',
      eVar119: 'DOTD-337',
      linkName: 'MFA Verification Success',
      eVar120: 'mfa-verification-success',
    });
  }
}
